import './i18next.js'
import GlobalModal from './globalModal.js'
import { TurnstileManager } from './turnstile'
import { PageLoading, LoginLoading } from './loading/index.js'

export default function installPlugin() {
  window.$globalModal = new GlobalModal()

  const turnstileManager = new TurnstileManager()
  window.$showTurnstile = turnstileManager.showTurnstile.bind(turnstileManager)

  const pageLoading = new PageLoading()
  const loginLoading = new LoginLoading()
  window.$showPageLoading = pageLoading.showLoading.bind(pageLoading)
  window.$showLoginLoading = loginLoading.showLoading.bind(loginLoading)

  window.dispatchEvent(new Event('onInstallPlugin'))
}

window.addEventListener('onLoadLocales', installPlugin)
